import Vue from 'vue'

const apis = {
  // 查询地址
  QUERY_AREA: {
    url: '/xdap-admin/province/query/province',
    method: 'post',
    disableSuccessMsg: true
  }
}

const queryArea = (params) => {
  return new Promise((resolve, reject) => {
    const request = {
      ...apis.QUERY_AREA,
      params
    }
    Vue.prototype
      .$request(request)
      .asyncThen(
        (resp) => {
          if (resp.code === 'ok') {
            resolve({
              data: resp.data
            })
          }
        },
        (err) => {
          reject(err)
        }
      )
      .asyncErrorCatch((err) => {
        reject(err)
      })
  })
}
export default {
  editorConfigType: 'AREA_DAFAULT',
  componentName: 'FormConfigAreaDefaultConfig',
  configProperty: 'areaDefault',
  extras: {
    queryArea: queryArea
  }
}
